/**
 * /start — public funnel entry point (marketing CTAs deep-link here, e.g.
 * app.legacyorb.com/start?plan=core).
 *
 * Captures the ?plan= slug in sessionStorage (used to preselect the package
 * on the intent + product-selection steps) and forwards to /start/account,
 * which shows the signup form when signed out and the guarded intent form
 * when signed in.
 *
 * Design: docs/technical-design-website-product.md §4.1
 */
import { Navigate, useSearchParams } from 'react-router-dom';
import { storePreferredPlanSlug } from '@/lib/funnel';

export function FunnelEntryPage() {
  const [searchParams] = useSearchParams();
  const plan = searchParams.get('plan');

  // Synchronous + idempotent — must happen before the redirect renders.
  if (plan) {
    storePreferredPlanSlug(plan);
  }

  return <Navigate to="/start/account" replace />;
}
